import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Input from '@mui/material/Input';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import IconButton from '@mui/material/IconButton';
import CustomLoader from '../CommonComponents/CustomLoader';
const classes = {
    loaderRoot: (theme) => ({
        color: theme.palette.background.default,
        padding: theme.spacing(0, 0.65),
    }),
};
const PdpQuantityCounter = ({ selectedVariant: { id: variantId, inventory_quantity: inventoryQuantity }, djangoPk, onAddToShopifyCart, width = { counter: '28%', btn: '70%' }, }) => {
    const [quantity, setQuantity] = useState(1);
    const [addingToCart, setAddingToCart] = useState(false);
    const handleAddToCart = async (e) => {
        e.preventDefault();
        setAddingToCart(true);
        gtag('event', 'add_to_cart');
        await onAddToShopifyCart({ id: variantId }, quantity, djangoPk);
        setAddingToCart(false);
    };
    const changeQuantityValue = async (e) => {
        const newQuantity = parseInt(e.target.value, 10);
        if (newQuantity !== quantity)
            setQuantity(newQuantity);
    };
    const keyPress = (e) => {
        if (e.key === 'Enter') {
            const newQuantity = parseInt(e.currentTarget.value, 10);
            if (newQuantity > inventoryQuantity) {
                setQuantity(inventoryQuantity);
            }
            else
                setQuantity(newQuantity);
        }
    };
    const changeQuantityOnClick = async (operation) => {
        if (operation === 'add') {
            setQuantity(quantity + 1);
        }
        else if (operation === 'minus') {
            if (quantity >= 1) {
                setQuantity(quantity - 1);
            }
        }
    };
    const inputButtonRootSX = {
        padding: 0.25,
        paddingLeft: 0.5,
        paddingRight: 0.5,
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '& svg': {
            fill: 'primary.dark',
        },
    };
    useEffect(() => {
        setQuantity(1);
    }, [variantId]);
    return (React.createElement(Box, { id: "quantity-counter", sx: { display: 'flex', justifyContent: 'space-between', marginTop: 2 } },
        React.createElement(Box, { sx: {
                width: width === null || width === void 0 ? void 0 : width.counter,
                display: 'inline-flex',
                border: 1,
                borderColor: 'secondary.dark',
                borderRadius: 1,
                marginRight: 1,
            } },
            React.createElement(IconButton, { sx: inputButtonRootSX, "aria-label": "minus", size: "small", onClick: () => changeQuantityOnClick('minus'), disabled: quantity === 1 || addingToCart },
                React.createElement(RemoveIcon, null)),
            React.createElement(Input, { value: quantity.toString(), sx: {
                    border: 'none',
                    '& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                        display: 'none',
                    },
                    '& .MuiInput-input': {
                        minWidth: 37,
                        height: 16,
                        textAlign: 'center',
                        MozAppearance: 'textfield',
                    },
                }, onChange: changeQuantityValue, onKeyDown: keyPress, type: "number", disableUnderline: true, inputProps: {
                    min: 1,
                    pattern: '[0-9]*',
                    'aria-label': 'quantity',
                } }),
            React.createElement(IconButton, { sx: inputButtonRootSX, "aria-label": "add", size: "small", onClick: () => changeQuantityOnClick('add'), disabled: quantity === inventoryQuantity || addingToCart },
                React.createElement(AddIcon, null))),
        React.createElement("button", { style: { width: width === null || width === void 0 ? void 0 : width.btn }, type: "button", className: "btn primary cart_btn", id: "addcart_btn", onClick: handleAddToCart, disabled: addingToCart }, addingToCart ? (React.createElement(CustomLoader, { loaderSx: classes.loaderRoot, loaderAttributes: { size: 20, thickness: 5 } })) : 'Add to Cart')));
};
export default PdpQuantityCounter;
